import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Wil je een tankpas voor particulier of zakelijk aanvragen?", -1)
const _hoisted_2 = { class: "field-radiobutton" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "b2c" }, "Particulier", -1)
const _hoisted_4 = { class: "field-radiobutton" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "b2b" }, "Zakelijk", -1)
const _hoisted_6 = {
  key: 0,
  class: "card"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Bedrijfs informatie", -1)
const _hoisted_8 = { class: "grid p-fluid" }
const _hoisted_9 = { class: "col-12 md:col-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "company_name" }, "Bedrijfsnaam", -1)
const _hoisted_11 = { class: "col-12 md:col-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "commercial_number" }, "KVK nummer", -1)
const _hoisted_13 = { class: "col-12 md:col-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "vat_number" }, "BTW nummer", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", { id: "vat_number-help" }, "Voorbeeld: NL123456789B01", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Naam", -1)
const _hoisted_17 = { class: "grid p-fluid" }
const _hoisted_18 = { class: "col-12 md:col-9" }
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "col-12 md:col-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "middle_name" }, "Middel naam", -1)
const _hoisted_22 = { class: "col-12 md:col-12" }
const _hoisted_23 = {
  key: 0,
  class: "p-error"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "Address", -1)
const _hoisted_25 = { class: "grid p-fluid" }
const _hoisted_26 = { class: "col-12 md:col-6" }
const _hoisted_27 = {
  key: 0,
  class: "p-error"
}
const _hoisted_28 = { class: "col-12 md:col-3" }
const _hoisted_29 = {
  key: 0,
  class: "p-error"
}
const _hoisted_30 = { class: "col-12 md:col-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "street_number_addition" }, "Toevoeging", -1)
const _hoisted_32 = { class: "col-12 md:col-4" }
const _hoisted_33 = {
  key: 0,
  class: "p-error"
}
const _hoisted_34 = { class: "col-12 md:col-4" }
const _hoisted_35 = {
  key: 0,
  class: "p-error"
}
const _hoisted_36 = { class: "col-12 md:col-4" }
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Contact informatie", -1)
const _hoisted_39 = { class: "grid p-fluid" }
const _hoisted_40 = { class: "col-12 md:col-6" }
const _hoisted_41 = {
  key: 0,
  class: "p-error"
}
const _hoisted_42 = { class: "col-12 md:col-6" }
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = { class: "col-12 md:col-6" }
const _hoisted_45 = {
  key: 0,
  class: "p-error"
}
const _hoisted_46 = { class: "col-12 md:col-6" }
const _hoisted_47 = {
  key: 0,
  class: "p-error"
}
const _hoisted_48 = { class: "col-12 md:col-12" }
const _hoisted_49 = {
  key: 0,
  class: "p-error"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "Kaart gegevens", -1)
const _hoisted_51 = { class: "grid p-fluid" }
const _hoisted_52 = { class: "col-12 md:col-3" }
const _hoisted_53 = { class: "field-radiobutton" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "subscription_false" }, "Abonnement uit", -1)
const _hoisted_55 = { class: "field-radiobutton" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "subscription_true" }, "Abonnement aan", -1)
const _hoisted_57 = { class: "col-12 md:col-3" }
const _hoisted_58 = { class: "field-radiobutton" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "card_type_fuel" }, "Tankpas", -1)
const _hoisted_60 = { class: "field-radiobutton" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "card_type_charge" }, "Laadpas", -1)
const _hoisted_62 = {
  key: 1,
  class: "card"
}
const _hoisted_63 = { class: "grid p-fluid" }
const _hoisted_64 = { class: "col-12 md:col-3" }
const _hoisted_65 = { class: "grid" }
const _hoisted_66 = { class: "md:col-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { for: "license_plate" }, "Kenteken", -1)
const _hoisted_68 = { class: "md:col-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "license_plate_country" }, "Kenteken land", -1)
const _hoisted_70 = { class: "md:col-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { for: "reference" }, "Auto kenmerk", -1)
const _hoisted_72 = { class: "md:col-3" }
const _hoisted_73 = { class: "field-checkbox" }
const _hoisted_74 = ["for"]
const _hoisted_75 = { class: "md:col-1" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("b", null, "Brandstof", -1)
const _hoisted_77 = { class: "grid" }
const _hoisted_78 = { class: "md:col-3" }
const _hoisted_79 = { class: "field-checkbox" }
const _hoisted_80 = ["for"]
const _hoisted_81 = { class: "md:col-3" }
const _hoisted_82 = { class: "field-checkbox" }
const _hoisted_83 = ["for"]
const _hoisted_84 = { class: "md:col-3" }
const _hoisted_85 = { class: "field-checkbox" }
const _hoisted_86 = ["for"]
const _hoisted_87 = { class: "md:col-3" }
const _hoisted_88 = { class: "field-checkbox" }
const _hoisted_89 = ["for"]
const _hoisted_90 = { class: "md:col-3" }
const _hoisted_91 = { class: "field-checkbox" }
const _hoisted_92 = ["for"]
const _hoisted_93 = { class: "md:col-3" }
const _hoisted_94 = { class: "field-checkbox" }
const _hoisted_95 = ["for"]
const _hoisted_96 = { class: "md:col-3" }
const _hoisted_97 = { class: "field-checkbox" }
const _hoisted_98 = ["for"]
const _hoisted_99 = { class: "md:col-3" }
const _hoisted_100 = { class: "field-checkbox" }
const _hoisted_101 = ["for"]
const _hoisted_102 = { class: "md:col-3" }
const _hoisted_103 = { class: "field-checkbox" }
const _hoisted_104 = ["for"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("b", null, "Auto gebonden", -1)
const _hoisted_106 = { class: "grid" }
const _hoisted_107 = { class: "md:col-3" }
const _hoisted_108 = { class: "field-checkbox" }
const _hoisted_109 = ["for"]
const _hoisted_110 = { class: "md:col-3" }
const _hoisted_111 = { class: "field-checkbox" }
const _hoisted_112 = ["for"]
const _hoisted_113 = { class: "md:col-3" }
const _hoisted_114 = { class: "field-checkbox" }
const _hoisted_115 = ["for"]
const _hoisted_116 = { class: "md:col-3" }
const _hoisted_117 = { class: "field-checkbox" }
const _hoisted_118 = ["for"]
const _hoisted_119 = { class: "md:col-6" }
const _hoisted_120 = { class: "field-checkbox" }
const _hoisted_121 = ["for"]
const _hoisted_122 = { class: "md:col-6" }
const _hoisted_123 = { class: "field-checkbox" }
const _hoisted_124 = ["for"]
const _hoisted_125 = { key: 2 }
const _hoisted_126 = { class: "grid p-fluid" }
const _hoisted_127 = { class: "col-12 md:col-4" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { for: "license_plate" }, "Kenteken", -1)
const _hoisted_129 = { class: "col-12 md:col-2" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", { for: "license_plate_country" }, "Kenteken land", -1)
const _hoisted_131 = { class: "col-12 md:col-4" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { for: "reference" }, "Auto kenmerk", -1)
const _hoisted_133 = { class: "col-12 md:col-2" }
const _hoisted_134 = { class: "field-checkbox" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { for: "allow_license_plate_recognition" }, "Kenteken herkenning", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("b", null, "Abonnement informatie", -1)
const _hoisted_137 = { class: "col-12 md:col-6" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { for: "subscription_product_backoffice_id" }, "Abonnement product ID", -1)
const _hoisted_139 = { class: "col-12 md:col-6" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", { for: "invoice_product_backoffice_id" }, "Invoice product ID", -1)
const _hoisted_141 = { class: "col-12 md:col-6" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", { for: "start_date" }, "Abonnement start datum", -1)
const _hoisted_143 = { class: "col-12 md:col-6" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", { for: "end_date" }, "Abonnement eind datum", -1)
const _hoisted_145 = { class: "col-12 md:col-6" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", { for: "invoice_period" }, "Facturatie cyclus", -1)
const _hoisted_147 = { class: "col-12 md:col-6" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", { for: "end_date" }, "Abonnement incasseren vanaf datum", -1)
const _hoisted_149 = { class: "col-12 md:col-12" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("label", { for: "payment_provider_redirect_url" }, "Redirect URL", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("b", null, "Brandstof", -1)
const _hoisted_152 = { class: "grid" }
const _hoisted_153 = { class: "md:col-3" }
const _hoisted_154 = { class: "field-checkbox" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_super_mlv' }, "MLV", -1)
const _hoisted_156 = { class: "md:col-3" }
const _hoisted_157 = { class: "field-checkbox" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_unleaded_98' }, "Euro 98 ongelood", -1)
const _hoisted_159 = { class: "md:col-3" }
const _hoisted_160 = { class: "field-checkbox" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_diesel' }, "Diesel", -1)
const _hoisted_162 = { class: "md:col-3" }
const _hoisted_163 = { class: "field-checkbox" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_lpg' }, "LPG", -1)
const _hoisted_165 = { class: "md:col-3" }
const _hoisted_166 = { class: "field-checkbox" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_mix' }, "MIX", -1)
const _hoisted_168 = { class: "md:col-3" }
const _hoisted_169 = { class: "field-checkbox" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_diesel_v_power' }, "Diesel ZV", -1)
const _hoisted_171 = { class: "md:col-3" }
const _hoisted_172 = { class: "field-checkbox" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_euro' }, "Euro", -1)
const _hoisted_174 = { class: "md:col-3" }
const _hoisted_175 = { class: "field-checkbox" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_gas_oil' }, "Gasolie", -1)
const _hoisted_177 = { class: "md:col-3" }
const _hoisted_178 = { class: "field-checkbox" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_petroleum' }, "Petroleum", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("b", null, "Auto gebonden", -1)
const _hoisted_181 = { class: "grid" }
const _hoisted_182 = { class: "md:col-3" }
const _hoisted_183 = { class: "field-checkbox" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_wash' }, "Wassen", -1)
const _hoisted_185 = { class: "md:col-3" }
const _hoisted_186 = { class: "field-checkbox" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_food' }, "Voedsel", -1)
const _hoisted_188 = { class: "md:col-3" }
const _hoisted_189 = { class: "field-checkbox" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_tobacco' }, "Tabak", -1)
const _hoisted_191 = { class: "md:col-3" }
const _hoisted_192 = { class: "field-checkbox" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_phone' }, "Telefoon", -1)
const _hoisted_194 = { class: "md:col-6" }
const _hoisted_195 = { class: "field-checkbox" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_oil' }, "Olie/Antivries/Ruitenvloeistof", -1)
const _hoisted_197 = { class: "md:col-6" }
const _hoisted_198 = { class: "field-checkbox" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { for: 'allowed_repair_service' }, "Diensten/Reparaties/Onderdelen", -1)
const _hoisted_200 = { class: "grid p-fluid" }
const _hoisted_201 = { class: "col-12 md:col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PMessage = _resolveComponent("PMessage")!
  const _component_PRadioButton = _resolveComponent("PRadioButton")!
  const _component_PDivider = _resolveComponent("PDivider")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PCheckbox = _resolveComponent("PCheckbox")!
  const _component_PTabPanel = _resolveComponent("PTabPanel")!
  const _component_PTabView = _resolveComponent("PTabView")!
  const _component_PCalendar = _resolveComponent("PCalendar")!
  const _component_PDropdown = _resolveComponent("PDropdown")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.handleSubmit(!_ctx.v$.$invalid)), ["prevent"])),
    class: "p-fluid"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardRequestStore.errors, (errorMessage, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_PMessage, { severity: "error" }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(errorMessage.field), 1),
            _createTextVNode(" " + _toDisplayString(errorMessage.message), 1)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PRadioButton, {
        inputId: "b2c",
        value: "B2C",
        modelValue: _ctx.form.customer_type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.customer_type) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_PRadioButton, {
        inputId: "b2b",
        value: "B2B",
        modelValue: _ctx.form.customer_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.customer_type) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_5
    ]),
    (_ctx.form.customer_type === 'B2B')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_PDivider, { align: "left" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_PInputText, {
                id: "company_name",
                modelValue: _ctx.form.customer.company.company_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.customer.company.company_name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_PInputText, {
                id: "commercial_number",
                modelValue: _ctx.form.customer.company.commercial_number,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.customer.company.commercial_number) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_PInputText, {
                id: "vat_number",
                modelValue: _ctx.form.customer.company.vat_number,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.customer.company.vat_number) = $event)),
                "aria-describedby": "vat_number-help"
              }, null, 8, ["modelValue"]),
              _hoisted_15
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PDivider, { align: "left" }, {
      default: _withCtx(() => [
        _hoisted_16
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("label", {
          for: "first_name",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.first_name.$invalid && _ctx.submitted })
        }, "Voornaam", 2),
        _createVNode(_component_PInputText, {
          id: "first_name",
          modelValue: _ctx.form.customer.first_name,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.customer.first_name) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.first_name.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.first_name.$invalid && _ctx.submitted) || _ctx.v$.form.customer.first_name.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.form.customer.first_name.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_PInputText, {
          id: "middle_name",
          modelValue: _ctx.form.customer.middle_name,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.customer.middle_name) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("label", {
          for: "last_name",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.last_name.$invalid && _ctx.submitted })
        }, "Achternaam", 2),
        _createVNode(_component_PInputText, {
          id: "last_name",
          modelValue: _ctx.form.customer.last_name,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.customer.last_name) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.last_name.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.last_name.$invalid && _ctx.submitted) || _ctx.v$.form.customer.last_name.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_ctx.v$.form.customer.last_name.required.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_PDivider, { align: "left" }, {
      default: _withCtx(() => [
        _hoisted_24
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", {
          for: "street",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.address.street.$invalid && _ctx.submitted })
        }, "Straat", 2),
        _createVNode(_component_PInputText, {
          id: "street",
          modelValue: _ctx.form.customer.address.street,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.customer.address.street) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.address.street.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.address.street.$invalid && _ctx.submitted) || _ctx.v$.form.customer.address.street.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.v$.form.customer.address.street.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("label", {
          for: "street_number",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.address.street_number.$invalid && _ctx.submitted })
        }, "Huisnummer", 2),
        _createVNode(_component_PInputNumber, {
          id: "street_number",
          modelValue: _ctx.form.customer.address.street_number,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.customer.address.street_number) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.address.street_number.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.address.street_number.$invalid && _ctx.submitted) || _ctx.v$.form.customer.address.street_number.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.v$.form.customer.address.street_number.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createVNode(_component_PInputText, {
          id: "street_number_addition",
          modelValue: _ctx.form.customer.address.street_number_addition,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.customer.address.street_number_addition) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", {
          for: "zip_code",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.address.zip_code.$invalid && _ctx.submitted })
        }, "Postcode", 2),
        _createVNode(_component_PInputText, {
          id: "zip_code",
          modelValue: _ctx.form.customer.address.zip_code,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.customer.address.zip_code) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.address.zip_code.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.address.zip_code.$invalid && _ctx.submitted) || _ctx.v$.form.customer.address.zip_code.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_33, _toDisplayString(_ctx.v$.form.customer.address.zip_code.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("label", {
          for: "city",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.address.city.$invalid && _ctx.submitted })
        }, "Stad", 2),
        _createVNode(_component_PInputText, {
          id: "city",
          modelValue: _ctx.form.customer.address.city,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.customer.address.city) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.address.city.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.address.city.$invalid && _ctx.submitted) || _ctx.v$.form.customer.address.city.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_ctx.v$.form.customer.address.city.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("label", {
          for: "country",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.address.country.$invalid && _ctx.submitted })
        }, "Land", 2),
        _createVNode(_component_PInputText, {
          id: "country",
          modelValue: _ctx.form.customer.address.country,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.customer.address.country) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.address.country.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.address.country.$invalid && _ctx.submitted) || _ctx.v$.form.customer.address.country.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(_ctx.v$.form.customer.address.country.required.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_PDivider, { align: "left" }, {
      default: _withCtx(() => [
        _hoisted_38
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("label", {
          for: "email",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.email.$invalid && _ctx.submitted })
        }, "E-mail", 2),
        _createVNode(_component_PInputText, {
          id: "email",
          modelValue: _ctx.form.customer.email,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.customer.email) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.email.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.email.$invalid && _ctx.submitted) || _ctx.v$.form.customer.email.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_41, _toDisplayString(_ctx.v$.form.customer.email.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("label", {
          for: "invoice_email",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.invoice_email.$invalid && _ctx.submitted })
        }, "Factuur e-mail", 2),
        _createVNode(_component_PInputText, {
          id: "invoice_email",
          modelValue: _ctx.form.customer.invoice_email,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.customer.invoice_email) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.invoice_email.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.invoice_email.$invalid && _ctx.submitted) || _ctx.v$.form.customer.invoice_email.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.v$.form.customer.invoice_email.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("label", {
          for: "mobile_number",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.mobile_number.$invalid && _ctx.submitted })
        }, "Mobiel", 2),
        _createVNode(_component_PInputText, {
          id: "mobile_number",
          modelValue: _ctx.form.customer.mobile_number,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.customer.mobile_number) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.mobile_number.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.mobile_number.$invalid && _ctx.submitted) || _ctx.v$.form.customer.mobile_number.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_45, _toDisplayString(_ctx.v$.form.customer.mobile_number.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("label", {
          for: "phone_number",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.phone_number.$invalid && _ctx.submitted })
        }, "Telefoonnummer", 2),
        _createVNode(_component_PInputText, {
          id: "phone_number",
          modelValue: _ctx.form.customer.phone_number,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.customer.phone_number) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.phone_number.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.phone_number.$invalid && _ctx.submitted) || _ctx.v$.form.customer.phone_number.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_47, _toDisplayString(_ctx.v$.form.customer.phone_number.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("label", {
          for: "iban",
          class: _normalizeClass({ 'p-error': _ctx.v$.form.customer.iban.$invalid && _ctx.submitted })
        }, "IBAN", 2),
        _createVNode(_component_PInputText, {
          id: "iban",
          modelValue: _ctx.form.customer.iban,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.customer.iban) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.form.customer.iban.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.form.customer.iban.$invalid && _ctx.submitted) || _ctx.v$.form.customer.iban.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_49, _toDisplayString(_ctx.v$.form.customer.iban.required.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_PDivider, { align: "left" }, {
      default: _withCtx(() => [
        _hoisted_50
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_PRadioButton, {
            inputId: "subscription_false",
            value: false,
            modelValue: _ctx.subscriptionOn,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.subscriptionOn) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_54
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_PRadioButton, {
            inputId: "subscription_true",
            disabled: _ctx.isFuelCard == false,
            value: true,
            modelValue: _ctx.subscriptionOn,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.subscriptionOn) = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _hoisted_56
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_PRadioButton, {
            inputId: "card_type_fuel",
            value: "fuel_card",
            modelValue: _ctx.form.card_type,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.card_type) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_59
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_PRadioButton, {
            inputId: "card_type_charge",
            value: "charge_card",
            modelValue: _ctx.form.card_type,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.card_type) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_61
        ])
      ])
    ]),
    (_ctx.subscriptionOn === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_PButton, {
                label: "Voeg kaart toe",
                autofocus: "",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addCard())),
                class: "p-button-success"
              })
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.cards, (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid p-fluid",
              key: index
            }, [
              _createVNode(_component_PTabView, {
                class: "md:col-12",
                style: {"box-shadow":"0 0 5px #ccc","margin":"7px 0px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PTabPanel, { header: "Kaart gegevens" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _hoisted_67,
                          _createVNode(_component_PInputText, {
                            id: "license_plate",
                            modelValue: card.license_plate,
                            "onUpdate:modelValue": ($event: any) => ((card.license_plate) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createVNode(_component_PInputText, {
                            id: "license_plate_country",
                            modelValue: card.license_plate_country,
                            "onUpdate:modelValue": ($event: any) => ((card.license_plate_country) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createVNode(_component_PInputText, {
                            id: "reference",
                            modelValue: card.reference,
                            "onUpdate:modelValue": ($event: any) => ((card.reference) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.allow_license_plate_recognition,
                              "onUpdate:modelValue": ($event: any) => ((card.allow_license_plate_recognition) = $event),
                              inputId: 'allow_license_plate_recognition' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allow_license_plate_recognition' + index
                            }, "Kenteken herkenning", 8, _hoisted_74)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_component_PButton, {
                            icon: "pi pi-times",
                            class: "p-button-rounded p-button-danger",
                            "aria-label": "Cancel",
                            onClick: ($event: any) => (_ctx.removeCard(index))
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_PTabPanel, { header: "Product restricties" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PDivider, { align: "left" }, {
                        default: _withCtx(() => [
                          _hoisted_76
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_super_mlv,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_super_mlv) = $event),
                              inputId: 'allowed_super_mlv' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_super_mlv' + index
                            }, "MLV", 8, _hoisted_80)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_unleaded_98,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_unleaded_98) = $event),
                              inputId: 'allowed_unleaded_98' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_unleaded_98' + index
                            }, "Euro 98 ongelood", 8, _hoisted_83)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_diesel,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_diesel) = $event),
                              inputId: 'allowed_diesel' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_diesel' + index
                            }, "Diesel", 8, _hoisted_86)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_lpg,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_lpg) = $event),
                              inputId: 'allowed_lpg' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_lpg' + index
                            }, "LPG", 8, _hoisted_89)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_mix,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_mix) = $event),
                              inputId: 'allowed_mix' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_mix' + index
                            }, "MIX", 8, _hoisted_92)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_diesel_v_power,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_diesel_v_power) = $event),
                              inputId: 'allowed_diesel_v_power' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_diesel_v_power' + index
                            }, "Diesel ZV", 8, _hoisted_95)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_euro,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_euro) = $event),
                              inputId: 'allowed_euro' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_euro' + index
                            }, "Euro", 8, _hoisted_98)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_gas_oil,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_gas_oil) = $event),
                              inputId: 'allowed_gas_oil' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_gas_oil' + index
                            }, "Gasolie", 8, _hoisted_101)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_petroleum,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_petroleum) = $event),
                              inputId: 'allowed_petroleum' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_petroleum' + index
                            }, "Petroleum", 8, _hoisted_104)
                          ])
                        ])
                      ]),
                      _createVNode(_component_PDivider, { align: "left" }, {
                        default: _withCtx(() => [
                          _hoisted_105
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_wash,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_wash) = $event),
                              inputId: 'allowed_wash' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_wash' + index
                            }, "Wassen", 8, _hoisted_109)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("div", _hoisted_111, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_food,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_food) = $event),
                              inputId: 'allowed_food' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_food' + index
                            }, "Voedsel", 8, _hoisted_112)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_tobacco,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_tobacco) = $event),
                              inputId: 'allowed_tobacco' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_tobacco' + index
                            }, "Tabak", 8, _hoisted_115)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("div", _hoisted_117, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_phone,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_phone) = $event),
                              inputId: 'allowed_phone' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_phone' + index
                            }, "Telefoon", 8, _hoisted_118)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_oil,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_oil) = $event),
                              inputId: 'allowed_oil' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_oil' + index
                            }, "Olie/Antivries/Ruitenvloeistof", 8, _hoisted_121)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", _hoisted_123, [
                            _createVNode(_component_PCheckbox, {
                              modelValue: card.product_restrictions.allowed_repair_service,
                              "onUpdate:modelValue": ($event: any) => ((card.product_restrictions.allowed_repair_service) = $event),
                              inputId: 'allowed_repair_service' + index,
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                            _createElementVNode("label", {
                              for: 'allowed_repair_service' + index
                            }, "Diensten/Reparaties/Onderdelen", 8, _hoisted_124)
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_125, [
          _createVNode(_component_PTabView, {
            class: "md:col-12",
            style: {"box-shadow":"0 0 5px #ccc","margin":"7px 0px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PTabPanel, { header: "Kaart gegevens" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _createVNode(_component_PInputText, {
                        id: "license_plate",
                        modelValue: _ctx.card.license_plate,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.card.license_plate) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _hoisted_130,
                      _createVNode(_component_PInputText, {
                        id: "license_plate_country",
                        modelValue: _ctx.card.license_plate_country,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.card.license_plate_country) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _hoisted_132,
                      _createVNode(_component_PInputText, {
                        id: "reference",
                        modelValue: _ctx.card.reference,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.card.reference) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", _hoisted_134, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.allow_license_plate_recognition,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.card.allow_license_plate_recognition) = $event)),
                          inputId: "allow_license_plate_recognition",
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_135
                      ])
                    ]),
                    _createVNode(_component_PDivider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_136
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_137, [
                      _hoisted_138,
                      _createVNode(_component_PInputText, {
                        id: "subscription_product_backoffice_id",
                        modelValue: _ctx.card.subscription.subscription_product_backoffice_id,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.card.subscription.subscription_product_backoffice_id) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _createVNode(_component_PInputText, {
                        id: "invoice_product_backoffice_id",
                        modelValue: _ctx.card.subscription.invoice_product_backoffice_id,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.card.subscription.invoice_product_backoffice_id) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _createVNode(_component_PCalendar, {
                        modelValue: _ctx.card.subscription.subscription_start_date,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.card.subscription.subscription_start_date) = $event)),
                        inputId: "start_date",
                        manualInput: false,
                        dateFormat: "dd-mm-yy",
                        showIcon: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _hoisted_144,
                      _createVNode(_component_PCalendar, {
                        modelValue: _ctx.card.subscription.subscription_end_date,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.card.subscription.subscription_end_date) = $event)),
                        inputId: "end_date",
                        manualInput: false,
                        dateFormat: "dd-mm-yy",
                        showIcon: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createVNode(_component_PDropdown, {
                        id: "invoice_period",
                        modelValue: _ctx.card.subscription.invoice_period,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.card.subscription.invoice_period) = $event)),
                        options: _ctx.directDebitEnum,
                        optionLabel: "name",
                        optionValue: "value"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _hoisted_148,
                      _createVNode(_component_PCalendar, {
                        modelValue: _ctx.card.subscription.subscription_direct_debit_start_date,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.card.subscription.subscription_direct_debit_start_date) = $event)),
                        inputId: "direct_debit_start_date",
                        manualInput: false,
                        dateFormat: "dd-mm-yy",
                        showIcon: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _hoisted_150,
                      _createVNode(_component_PInputText, {
                        id: "payment_provider_redirect_url",
                        modelValue: _ctx.card.subscription.payment_provider_redirect_url,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.card.subscription.payment_provider_redirect_url) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_PTabPanel, { header: "Product restricties" }, {
                default: _withCtx(() => [
                  _createVNode(_component_PDivider, { align: "left" }, {
                    default: _withCtx(() => [
                      _hoisted_151
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_super_mlv,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.card.product_restrictions.allowed_super_mlv) = $event)),
                          inputId: 'allowed_super_mlv',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_155
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("div", _hoisted_157, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_unleaded_98,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.card.product_restrictions.allowed_unleaded_98) = $event)),
                          inputId: 'allowed_unleaded_98',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_158
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_159, [
                      _createElementVNode("div", _hoisted_160, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_diesel,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.card.product_restrictions.allowed_diesel) = $event)),
                          inputId: 'allowed_diesel',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_161
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("div", _hoisted_163, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_lpg,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.card.product_restrictions.allowed_lpg) = $event)),
                          inputId: 'allowed_lpg',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_164
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_mix,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.card.product_restrictions.allowed_mix) = $event)),
                          inputId: 'allowed_mix',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_167
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_168, [
                      _createElementVNode("div", _hoisted_169, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_diesel_v_power,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.card.product_restrictions.allowed_diesel_v_power) = $event)),
                          inputId: 'allowed_diesel_v_power',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_170
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("div", _hoisted_172, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_euro,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.card.product_restrictions.allowed_euro) = $event)),
                          inputId: 'allowed_euro',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_173
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", _hoisted_175, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_gas_oil,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.card.product_restrictions.allowed_gas_oil) = $event)),
                          inputId: 'allowed_gas_oil',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_176
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_petroleum,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.card.product_restrictions.allowed_petroleum) = $event)),
                          inputId: 'allowed_petroleum',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_179
                      ])
                    ])
                  ]),
                  _createVNode(_component_PDivider, { align: "left" }, {
                    default: _withCtx(() => [
                      _hoisted_180
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", _hoisted_183, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_wash,
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.card.product_restrictions.allowed_wash) = $event)),
                          inputId: 'allowed_wash',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_184
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_185, [
                      _createElementVNode("div", _hoisted_186, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_food,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.card.product_restrictions.allowed_food) = $event)),
                          inputId: 'allowed_food',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_187
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _createElementVNode("div", _hoisted_189, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_tobacco,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.card.product_restrictions.allowed_tobacco) = $event)),
                          inputId: 'allowed_tobacco',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_190
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_191, [
                      _createElementVNode("div", _hoisted_192, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_phone,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.card.product_restrictions.allowed_phone) = $event)),
                          inputId: 'allowed_phone',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_193
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("div", _hoisted_195, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_oil,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.card.product_restrictions.allowed_oil) = $event)),
                          inputId: 'allowed_oil',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_196
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_197, [
                      _createElementVNode("div", _hoisted_198, [
                        _createVNode(_component_PCheckbox, {
                          modelValue: _ctx.card.product_restrictions.allowed_repair_service,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.card.product_restrictions.allowed_repair_service) = $event)),
                          inputId: 'allowed_repair_service',
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_199
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])),
    _createElementVNode("div", _hoisted_200, [
      _createElementVNode("div", _hoisted_201, [
        _createVNode(_component_PButton, {
          type: "submit",
          label: "Submit",
          class: "mt-2"
        })
      ])
    ])
  ], 32))
}